import React from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from '@material-ui/core'

const fmt = (v) => (v || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })

const calcMargin = (cost, sell) => {
  if (!sell) return '—'
  return (((sell - cost) / sell) * 100).toFixed(1) + '%'
}

const SectionBreakdown = ({ bySection, byBuilding, selectedBuilding }) => {
  const data = React.useMemo(() => {
    if (selectedBuilding && byBuilding && byBuilding[selectedBuilding]) {
      // When a building is selected, show its section-level data if available
      // For now, show building aggregate as a single row (section-level per building is a future enhancement)
      const bld = byBuilding[selectedBuilding]
      return [{
        section: selectedBuilding + ' (All Sections)',
        items: bld.items || 0,
        totalCost: bld.totalCost || 0,
        totalSell: bld.totalSell || 0
      }]
    }

    if (!bySection) return []
    return Object.entries(bySection).map(([name, vals]) => ({
      section: name,
      items: vals.items || 0,
      totalCost: vals.totalCost || 0,
      totalSell: vals.totalSell || 0
    })).sort((a, b) => a.section.localeCompare(b.section))
  }, [bySection, byBuilding, selectedBuilding])

  const totals = React.useMemo(() => {
    return data.reduce((acc, row) => ({
      items: acc.items + row.items,
      totalCost: acc.totalCost + row.totalCost,
      totalSell: acc.totalSell + row.totalSell
    }), { items: 0, totalCost: 0, totalSell: 0 })
  }, [data])

  if (!data.length) {
    return (
      <Paper style={{ padding: 20, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          No section data available.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>Section</strong></TableCell>
            <TableCell align="right"><strong>Items</strong></TableCell>
            <TableCell align="right"><strong>Total Cost</strong></TableCell>
            <TableCell align="right"><strong>Total Sell</strong></TableCell>
            <TableCell align="right"><strong>Margin %</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.section} hover>
              <TableCell>{row.section}</TableCell>
              <TableCell align="right">{row.items}</TableCell>
              <TableCell align="right">{fmt(row.totalCost)}</TableCell>
              <TableCell align="right">{fmt(row.totalSell)}</TableCell>
              <TableCell align="right">{calcMargin(row.totalCost, row.totalSell)}</TableCell>
            </TableRow>
          ))}
          <TableRow style={{ backgroundColor: '#f5f5f5' }}>
            <TableCell><strong>Grand Total</strong></TableCell>
            <TableCell align="right"><strong>{totals.items}</strong></TableCell>
            <TableCell align="right"><strong>{fmt(totals.totalCost)}</strong></TableCell>
            <TableCell align="right"><strong>{fmt(totals.totalSell)}</strong></TableCell>
            <TableCell align="right"><strong>{calcMargin(totals.totalCost, totals.totalSell)}</strong></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  )
}

export default SectionBreakdown
